import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Importa useLocation
import Swal from 'sweetalert2';
import { TranslatorContext } from "../../context/Translator";
import { Dropdown, Tab, Tabs,Form } from "react-bootstrap";
import users from "../../assets/data/users.json";
import { AnchorComponent, ButtonComponent } from "../elements";
import Modal from 'react-bootstrap/Modal';
import {getApoderdosGiras, 
        getAlumnosGira, 
        getAlumno,
        getAlumnosEliminadosGira, 
        enviarListadoapoderados, 
        eliminarAlumnoGira, 
        agregareliminarAlumnoGira,
        cuotasAlumno,
        agregarAlumnoGira,
        descargarPlanillaAduana,
        descargarPlanillaInterna, 
        descargarLogAcceso,  
        registrarPagosFuncionario,
        enviarDocumentos,
        getDocumentosGira,
        editarAlumnoGira
        } from "../../api/giras.ts";
import {getTipoPasajeros, descargarArchivo} from "../../api/mantenedores.ts";      
import {SingleFileUploadButton} from "../upload/SingleFileUploadButton.tsx";


export default function ListadoUsuariosGiraComponent({gira}) {

    
    const { t } = useContext(TranslatorContext)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalAgregar, setAlertModalAgregar] = useState(false);
    const [alertModalDetalle, setAlertModalDetalle] = useState(false);
    const [alertModalEliminar, setAlertModalEliminar] = useState(false);
    const [idgira, setIdGira] = useState("");
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showUploadModalDoc, setShowUploadModalDoc] = useState(false);
    const [showAddPassengerModal, setShowAddPassengerModal] = useState(false);
    const [selectedAlumno, setSelectedAlumno] = useState(null);
    const [file, setFile] = useState("");
    const [fileDoc, setFileDoc] = useState("");
    const [alumnoSelecionado, setAlumnoSelecionado] = useState(null);

     const [selectedCuotas, setSelectedCuotas] = useState([]);
     const [totalMonto, setTotalMonto] = useState(0);
     const [valorGiraAlumno, setValorGiraAlumno] = useState(0);
     const [valorAbono, setValorAbono] = useState(0);

    const [multasModificadas, setMultasModificadas] = useState({});
    const [detalleModificadas, setDetalleModificadas] = useState({});

    const [errors, setErrors] = useState({});

    const [passengerData, setPassengerData] = useState({
        nombres: '',
        apellidos: '',
        rut: '',
        calidad:'',
        idcalidad: '',
        fnacimiento: '',
        sexo: '',
        alergia: '',
        nacionalidad: '',
        edad: '',

    });
    const [cuotasAlumnoGira, setCuotasAlumnoGira] = useState([]);
    const [apoderados, setApoderados] = useState([]);
    const [apoderado, setApoderado] = useState([]);
    const [alumnos, setAlumnos] = useState([]); 
    const [tipoPasajeros, setTipoPasajeros] = useState([]);
    const [alumnosEliminados, setAlumnosEliminados] = useState([]);
    const [documentosGira, setDocumentosGira] = useState([]); 

    const acceptTypes = {
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
          ".xlsx"
        ]
        // Agrega más tipos de archivo según tus necesidades
      };

    const acceptTypesDoc = {
        "application/pdf": [".pdf"]
        // Agrega más tipos de archivo según tus necesidades
      };
    

    const handleShowUploadModal = () => setShowUploadModal(true);
    const handleShowUploadDocModal = () => setShowUploadModalDoc(true);
    const handleCloseUploadModal = () => setShowUploadModal(false);
    const handleCloseUploadModalDoc = () => setShowUploadModalDoc(false);
    const handleShowAddPassengerModal = () => setShowAddPassengerModal(true);
    const handleCloseAddPassengerModal = () => setShowAddPassengerModal(false);
    
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
        const giraId = params.get('gira'); // Obtén el valor del parámetro 'gira'
        setIdGira(giraId);
        const fetchTablaApoderados = async () => {  
            const res = await getApoderdosGiras(giraId);
            setApoderados(res);
        } 

        const fetchTablaAlumnos = async () => {
            const res = await getAlumnosGira(giraId);
            setAlumnos(res);
        }


        const fetchTablaAlumnosEliminados = async () => {
            const res = await getAlumnosEliminadosGira(giraId);
            setAlumnosEliminados(res);
        }


        const fetchTablaDocumento = async () => {
            const res = await getDocumentosGira(giraId);
            setDocumentosGira(res);
        }


        const fetchTipoPasajeros = async () => {
            const res = await getTipoPasajeros();
          
            setTipoPasajeros(res.data);
        }

        
        fetchTablaApoderados();
        fetchTablaAlumnos();
        fetchTablaAlumnosEliminados();
        fetchTipoPasajeros();
        fetchTablaDocumento();
                   
    }, []);
    

    const fetchTablaApoderados = async (giraId) => {  
        const res = await getApoderdosGiras(giraId);
        setApoderados(res);
    } 

    const fetchTablaAlumnos = async (giraId) => {
        const res = await getAlumnosGira(giraId);
        setAlumnos(res);
    }

    const fetchTablaAlumnosEliminados = async (giraId) => {
        const res = await getAlumnosEliminadosGira(giraId);
        setAlumnosEliminados(res);
    }

    const handleFileUpload = (e) => {
        console.log(e);
        if (e != null) setFile(e.id);
        else setFile("");
    };

    const handleFileUploadDoc = (e) => {
        console.log(e);
        if (e != null) setFileDoc(e.id);
        else setFileDoc("");
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setPassengerData({
            ...passengerData,
            [name]: value
        });
    };

    const handleAddPassenger = () => {
        // Aquí puedes manejar la lógica para agregar el pasajero
       
        handleCloseAddPassengerModal();
    };

    const validateForm = () => {
        const newErrors = {};
    
       
    
        if (file === "") {
          newErrors.file = "Debe seleccionar un archivo";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };


      const validateFormDoc = () => {
        const newErrors = {};
    
       
    
        if (fileDoc === "") {
          newErrors.file = "Debe seleccionar un archivo";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

    const handleCargarData = (e) => {
        console.log(file);
        if (validateForm()) {
          e.preventDefault();
    
          Swal.fire({
            title: "Cargando apoderados",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
         
            enviarListadoapoderados(file, idgira).then((res) => {
              Swal.close();
              if (res.error === false) {
                
                Swal.fire({
                  icon: "success",
                  text: res.msg
                });
                window.location.reload();
                fetchTablaApoderados(idgira);
                fetchTablaAlumnos(idgira);
                fetchTablaAlumnosEliminados(idgira);
                
              } else {
                Swal.fire({
                  icon: "error",
                  text: res.msg
                });
              }
            });
        
        }
      };

       const handleCargarDataDoc = (e) => {
       
        if (validateFormDoc()) {
          e.preventDefault();
    
          Swal.fire({
            title: "Cargando documento",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
         
            enviarDocumentos(fileDoc, idgira).then((res) => {
              Swal.close();
              if (res.error === false) {
                
                Swal.fire({
                    icon: "success",
                    text: "Operación exitosa."
                    }).then(() => {
                    window.location.reload();
                    });

                setFileDoc("");
                //navigateTo(ROUTES.CARGAINDICADORES);
              } else {
                Swal.fire({
                  icon: "error",
                  text: res.msg
                });
              }
            });
        
        }
      };

      
          const handleDownload = async (fileId, fileName) => {
                  try {
                    const response = await descargarArchivo(fileId, 'pdf');
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Nombre del archivo
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                  } catch (error) {
                    Swal.fire({
                      icon: 'error',
                      text: 'Error al descargar el archivo'
                    });
                  }
          };

    const handleDeleteAlumno = () => {
        if (selectedAlumno) {
            /*setAlumnos(alumnos.filter(alumno => alumno !== selectedAlumno));
            setAlertModal(false);
            Swal.fire({
                icon: "success",
                text: "Alumno eliminado correctamente."
            });*/
            setAlertModalEliminar(false);
            Swal.fire({
                title: "Eliminando Alumno",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
             
              eliminarAlumnoGira(selectedAlumno.alu_id, idgira).then((res) => {
                  Swal.close();
                  if (res.error === false) {
                  
                        fetchTablaApoderados(idgira);
                        fetchTablaAlumnos(idgira);
                        fetchTablaAlumnosEliminados(idgira);
                
                    Swal.fire({
                      icon: "success",
                      text: "Alumno eliminado de la Gira."
                    });
                    //navigateTo(ROUTES.CARGAINDICADORES);
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: res.msg
                    });
                  }
                });
        }
    };

    const handleAgregarAlumno = () => {
        if(apoderado){
            setAlertModalAgregar(false);
            Swal.fire({
                title: "Agregando Alumno",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
             
              agregarAlumnoGira(apoderado.apo_id, idgira, passengerData).then((res) => {
                  Swal.close();
                  if (res.error === false) {
                  
                        fetchTablaApoderados(idgira);
                        fetchTablaAlumnos(idgira);
                        fetchTablaAlumnosEliminados(idgira);

                    Swal.fire({
                      icon: "success",
                      text: "Alumno agregado a la Gira."
                    });
                    //navigateTo(ROUTES.CARGAINDICADORES);
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: res.msg
                    });
                  }
                });
        }
    };

    const handleDescargaAduana = () => {
        Swal.fire({
            title: "Descargando Planilla Aduana",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          descargarPlanillaAduana(idgira).then((res) => {
              Swal.close();
              if (res.error === true) {
                Swal.fire({
                  icon: 'success',
                  text: 'Reporte generado correctamente.'
                })
                //navigateTo(ROUTES.USUARIOS);
              }else{
                const url = window.URL.createObjectURL(res);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'planila_aduana.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                //  window.URL.revokeObjectURL(url);
              }
            });     
    }

    const handleDescargaLogAcceso = () => {
        Swal.fire({
            title: "Descargando Planilla de Log de Acceso",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          descargarLogAcceso(idgira).then((res) => {
              Swal.close();
              if (res.error === true) {
                Swal.fire({
                  icon: 'success',
                  text: 'Reporte generado correctamente.'
                })
                //navigateTo(ROUTES.USUARIOS);
              }else{
                const url = window.URL.createObjectURL(res);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'reporte_log_acceso.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                //  window.URL.revokeObjectURL(url);
              }
            });     
    }

    const handleDescargaInterna = () => {
        Swal.fire({
            title: "Descargando Planilla Interna",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          descargarPlanillaInterna(idgira).then((res) => {
              Swal.close();
              if (res.error === true) {
                Swal.fire({
                  icon: 'success',
                  text: 'Reporte generado correctamente.'
                })
                //navigateTo(ROUTES.USUARIOS);
              }else{
                const url = window.URL.createObjectURL(res);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'planila_interna.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                //  window.URL.revokeObjectURL(url);
              }
            });     
    }

    const handleMultaChange = (cuotaId, nuevaMulta) => {
        const nuevaMultaNumerica = parseFloat(nuevaMulta) || 0; // Convertir la nueva multa a número o usar 0 si no es válida

    // Actualizar la multa modificada
    setMultasModificadas((prevState) => ({
        ...prevState,
        [cuotaId]: nuevaMultaNumerica,
    }));

    console.log("Multas Modificadas:", multasModificadas);

        // Recalcular el monto "A Pagar" y el "Total a Pagar"
        const nuevasCuotas = cuotasAlumnoGira.map((cuota) => {
           
            if (cuota.cuo_id === cuotaId) {
                return {
                    ...cuota,
                    multa: nuevaMultaNumerica,
                    aPagar: cuota.cou_valor + nuevaMultaNumerica, // Actualizar el monto "A Pagar"
                };
            }
            return cuota;
        });

        console.log("Nuevas Cuotas:", nuevasCuotas);

        setCuotasAlumnoGira(nuevasCuotas);
        console.log("Cuotas Alumno Gira:", nuevasCuotas);

        console.log("Selected Cuotas:", selectedCuotas);

         // Recalcular el total a pagar solo para las cuotas seleccionadas
        const nuevoTotalMonto = selectedCuotas.reduce((total, cuotaSeleccionada) => {
            const cuotaActualizada = nuevasCuotas.find((cuota) => cuota.cuo_id === cuotaSeleccionada.cuo_id);
            return total + (cuotaActualizada?.aPagar || (cuotaSeleccionada.cou_valor +  cuotaSeleccionada.multa));
        }, 0);

        setTotalMonto(nuevoTotalMonto);
        };

        const handleDetalleChange = (cuotaId, detalle) => {
            setDetalleModificadas({
                ...detalleModificadas,
                [cuotaId]: detalle || '', // Actualizar la multa para la cuota específica
            });
    };

    const handleActualizaDatos = async (e) => {
        e.preventDefault();
        Swal.fire({
            title: "Actualizando Datos",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          editarAlumnoGira(alumnoSelecionado, passengerData).then((res) => {
            Swal.close();
             Swal.close();
                Swal.fire({
                    icon: 'success',
                    text: 'Datos actualizados correctamente.'
                });
          });
          

       
        
    };
    

    const handlePay = async () => {
        // Lógica para procesar el pago
        Swal.fire({
            title: "Registrando pago",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
         registrarPagosFuncionario(selectedCuotas, multasModificadas, detalleModificadas).then(async (res) => {
            Swal.close();
            const restCuotas = await cuotasAlumno(alumnoSelecionado);
            const sumaTotalCuotas = restCuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);


            const totalCuotasPagadas = restCuotas.filter(cuota => cuota.cou_fpago) // Solo cuotas pagadas (cou_fpago no nulo)
                                        .reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);

             setValorGiraAlumno(sumaTotalCuotas);
            setValorAbono( totalCuotasPagadas);

            // Calcular multas para todas las cuotas
            const nuevasMultas = {};
            for (let i = 0; i < restCuotas.length; i++) {
                const cuota = restCuotas[i];
             
                nuevasMultas[cuota.cuo_id] = cuota.multa;
            }
            setMultasModificadas(nuevasMultas);
                                        
            setCuotasAlumnoGira(restCuotas);
            setTotalMonto(0);
            setSelectedCuotas([]);
            Swal.fire({
                icon: 'success',
                text: 'Pago realizado correctamente.'
            });
        }
        );

    };

    function convertirFecha(fecha) {
        if (!fecha) return "";
        const [dia, mes, anio] = fecha.split("/");
        return `${anio}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
        }

  const handleShowDetalleAlumno = async (alumno) => {
    const res = await getAlumno(alumno.alu_id);
    const restCuotas = await cuotasAlumno(alumno.alu_id);
    setAlumnoSelecionado(alumno.alu_id);
    setPassengerData({
      nombres: res.alu_nombres,
      apellidos: res.alu_apellidos,
      rut: `${res.alu_rut}-${res.alu_dv}`,
      calidad: res.calidad,
      idcalidad: res.idcalidad,
      fechaNacimiento: res.alu_fnacimiento,
      fechaNacimientoAct: convertirFecha(res.alu_fnacimiento),
      sexo: res.sexo,
      alergia: res.alergia,
        nacionalidad: res.alu_nacionalidad,
        edad: res.edad,
    });

   
     const sumaTotalCuotas = restCuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);


    const totalCuotasPagadas = restCuotas.filter(cuota => cuota.cou_fpago) // Solo cuotas pagadas (cou_fpago no nulo)
                                        .reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);


    setValorGiraAlumno(sumaTotalCuotas);
    setValorAbono( totalCuotasPagadas);

     // Calcular multas para todas las cuotas
    const nuevasMultas = {};
    for (let i = 0; i < restCuotas.length; i++) {
        const cuota = restCuotas[i];
        
        nuevasMultas[cuota.cuo_id] = cuota.multa;
    }
    setMultasModificadas(nuevasMultas);

    setCuotasAlumnoGira(restCuotas);
   
    setAlertModalDetalle(true);
    setTotalMonto(0);
    setSelectedCuotas([]);
  };

  const handleCheckboxChange = (cuota, proximaFechaVencimiento) => {
    const isSelected = selectedCuotas.some((item) => item.cuo_id === cuota.cuo_id);
    let newSelectedCuotas;
    let newTotalMonto;

    // Usar la multa modificada si existe, de lo contrario usar la calculada
    
    const multa = multasModificadas[cuota.cuo_id];
   
    if (isSelected) {
        // Si ya está seleccionado, eliminarlo
        newSelectedCuotas = selectedCuotas.filter((item) => item.cuo_id !== cuota.cuo_id);
        newTotalMonto = totalMonto - Number(cuota.cou_valor + multa);
    } else {
        // Si no está seleccionado, agregarlo con la multa
        newSelectedCuotas = [...selectedCuotas, { cuo_id: cuota.cuo_id, multa, cou_valor: cuota.cou_valor }];
        newTotalMonto = totalMonto + Number(cuota.cou_valor + multa);
    }
   console.log("Selected Cuotas:", newSelectedCuotas);
    setSelectedCuotas(newSelectedCuotas);
    setTotalMonto(newTotalMonto);
};


 const calculateMulta = (fechaVencimiento, valorGira, proximaFechaVencimiento = null) => {
    // fechaVencimiento y proximaFechaVencimiento en formato 'dd-mm-yyyy'
    const [day, month, year] = fechaVencimiento.split('-').map(Number);
    const fechaVenc = new Date(year, month - 1, day);

    // Sumar un día para que la multa empiece al día siguiente
    fechaVenc.setDate(fechaVenc.getDate() + 1);
    const fechaActual = new Date(); // fecha actual
    if(fechaActual <= fechaVenc ){
        return 0; // Si la fecha actual es antes o igual a la fecha de vencimiento, no hay multa
    }

    // Determinar hasta cuándo calcular la multa
    let fechaLimite;
    if (proximaFechaVencimiento) {
        const [nextDay, nextMonth, nextYear] = proximaFechaVencimiento.split('-').map(Number);
        fechaLimite = new Date(nextYear, nextMonth - 1, nextDay);
        if(fechaLimite >= fechaActual){
            fechaLimite = new Date(); // Si la próxima cuota es antes o igual a la fecha de vencimiento, no hay multa
        }
    } else {
        fechaLimite = new Date(); // fecha actual si no hay próxima cuota
    }

    // Si la fecha límite es menor o igual a la fecha de inicio de multa, no hay multa
    if (fechaLimite <= fechaVenc) {
        return 0;
    }
   
    if(gira.gir_mulmensual?.data[0]){
        
        return  Math.floor(valorGira * (gira.gir_porcmulta / 100) ); // 1% por semana
    }else{
         // Calcular semanas completas de atraso
        
        const diferenciaEnMilisegundos = fechaLimite - fechaVenc;
        const semanasAtraso = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24 * 7));
       
        if(semanasAtraso === 0){
            return  Math.floor((1)  * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
        }
        return  Math.floor((semanasAtraso )  * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
    }
   
};

    return (
        <div className="mc-card">
            <div className="mc-card-header">
                <h4 className="mc-card-title">Pasajeros</h4>
                <Dropdown bsPrefix="mc-dropdown">
                    <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                        <i className='material-icons'>more_horiz</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" className="mc-dropdown-paper">
                        <button type='button' className='mc-dropdown-menu' onClick={handleShowUploadModal}><i className='material-icons'>person</i><span>Agregar Apoderados</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleShowUploadDocModal}><i className='material-icons'>upload</i><span>Agregar Documentación Anexa</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleDescargaInterna}><i className='material-icons'>download</i><span>Descargar Planilla Interna</span></button>
                        <button type='button' className='mc-dropdown-menu'  onClick={handleDescargaAduana}><i className='material-icons'>download</i><span>Descargar Planilla Aduana</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleDescargaLogAcceso}><i className='material-icons'>download</i><span>Descargar Planilla Log de Acceso</span></button>
                    </Dropdown.Menu>
                </Dropdown> 
            </div>
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                <Tab eventKey="profile" title="Responsables" className="mc-tabpane profile">
                <ul className="mc-activity-card-list thin-scrolling">
               
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                         <th >Nombres</th>
                         <th >Apellido</th>
                         <th >RUT</th>
                         <th >Parentesco</th>
                         <th >Alumnos</th>
                         <th ></th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {apoderados?.map((item, index) => (
                            <tr key={ index }> 
                                <td title="id">
                                { item.usu_nombre }
                                </td>
                                <td title={ item.usu_apellido }>
                                { item.usu_apellido }
                                </td>
                                <td title={ item.name }>
                                { item.usu_rut }-{ item.usu_dv }
                                </td>
                                <td title={ item.status }>
                                { item.patentesco }
                                </td>
                               
                                <td title={ item.status }>
                                { item.alumnos }
                                </td>
                                
                                <td>
                                    <div className="mc-table-action">
                                    <ButtonComponent title="Agregar Alumno" onClick={()=>{setApoderado(item);  setAlertModalAgregar(true)}} className="material-icons edit"><i className='material-icons'>person_add</i></ButtonComponent>  
                                   
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
               
                    
                    </ul>
                </Tab>
                <Tab eventKey="alumnos" title="Pasajeros" className="mc-tabpane alumnos">
                <ul className="mc-activity-card-list thin-scrolling">
               
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                         <th >Nombres</th>
                         <th >Apellido</th>
                         <th >RUT</th>
                        
                       
                         <th >Calidad</th>
                         <th >Estado</th>
                         <th ></th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {alumnos?.map((item, index) => (
                            <tr key={ index }> 
                                <td title="id">
                                { item.alu_nombres }
                                </td>
                                <td title={ item.name }>
                                { item.alu_apellidos }
                                </td>
                                <td title={ item.name }>
                                { item.alu_rut }-{ item.alu_dv }
                                </td>
                            
                                <td title={ item.calidad }>
                                { item.calidad }
                                </td>
                               
                                <td title={ item.status }>
                                    { item.genero !== null && <p className="mc-table-badge green">Información Completada</p> }
                                    { item.genero === null && <p className="mc-table-badge red">Sin Información</p> }
                                    { item.cuotas_pagadas_completas === 'PENDIENTE' && <p className="mc-table-badge red">Pendiente de Pago</p> }
                                    { item.cuotas_pagadas_completas === 'PAGADO' && <p className="mc-table-badge green">Pago Completado</p> }
                                </td>
                                
                                <td>
                                    <div className="mc-table-action">
                                    <AnchorComponent  title="ver" onClick={() => handleShowDetalleAlumno(item)} className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                     <ButtonComponent title="Eliminar" onClick={() => { setSelectedAlumno(item); setAlertModalEliminar(true); }}  className="material-icons block"><i className='material-icons'>delete</i></ButtonComponent>  
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
               
                    
                    </ul>
                </Tab>
                <Tab eventKey="password" title="Pasajeros Eliminados" className="mc-tabpane password">
                <ul className="mc-activity-card-list thin-scrolling">
               
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                        <th >Nombres</th>
                         <th >Apellido</th>
                         <th >RUT</th>
                        
                        
                        
                       
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {alumnosEliminados?.map((item, index) => (
                            <tr key={ index }> 
                                <td title="id">
                                { item.alu_nombres }
                                </td>
                                <td title={ item.name }>
                                { item.alu_apellidos }
                                </td>
                                <td title={ item.name }>
                                { item.alu_rut }-{ item.alu_dv }
                                </td>
                              
                               
                                <td title={ item.status }>
                                    { item.status === "approved" && <p className="mc-table-badge green">{ item.status }</p> }
                                    { item.status === "pending" && <p className="mc-table-badge purple">{ item.status }</p> }
                                    { item.status === "blocked" && <p className="mc-table-badge red">{ item.status }</p> }
                                </td>
                                
                             
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
              
                    </ul>
                </Tab> 
                <Tab eventKey="documentos" title="Documentos" className="mc-tabpane documentos">
                <ul className="mc-activity-card-list thin-scrolling">
               
                   <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                        <th >Nombre Archivo</th>
                        <th >Descargar</th>
                        
                        
                        
                        
                       
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {documentosGira?.map((item, index) => (
                            <tr key={ index }>  

                                <td title="id">
                                { item.doc_nombre }
                                </td>   
                                <td title="id">
                                 <button type='button' className='mc-dropdown-menu' onClick={() => handleDownload(item.fil_id,  item.doc_nombre)}><i className='material-icons'>download</i><span>Descargar</span></button>
                                </td>  
                            </tr>
                            
                        ))}    

                    </tbody>
                    </table>
    
              
                    </ul>
                </Tab>    
            </Tabs>    
           
            <Modal show={ alertModal } onHide={()=> setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>¿Desea eliminar este usuario?</h3>
                  
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> setAlertModal(false)}>Aceptar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            <Modal show={showUploadModal} onHide={handleCloseUploadModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Subir Listado de Pasajeros</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SingleFileUploadButton
                        onFileUpload={handleFileUpload}
                        type="Xlsx"
                        acceptTypes={acceptTypes}
                        maxSize="50"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseUploadModal}>
                            Cerrar
                        </ButtonComponent>
                        <ButtonComponent variant="primary" className="btn btn-secondary" onClick={handleCargarData}>
                            Subir
                        </ButtonComponent>
                    </Modal.Footer>
                    </div>
            </Modal>

            <Modal show={showUploadModalDoc} onHide={handleCloseUploadModalDoc}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Subir Documentación Anexa</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SingleFileUploadButton
                        onFileUpload={handleFileUploadDoc}
                        type="pdf"
                        acceptTypes={acceptTypesDoc}
                        maxSize="50"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseUploadModalDoc}>
                            Cerrar
                        </ButtonComponent>
                        <ButtonComponent variant="primary" className="btn btn-secondary" onClick={handleCargarDataDoc}>
                            Subir
                        </ButtonComponent>
                    </Modal.Footer>
                    </div>
            </Modal>

            <Modal show={showAddPassengerModal} onHide={handleCloseAddPassengerModal}>
            <div className="mc-alert-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formNombres">
                            <Form.Label>Nombres</Form.Label>
                            <Form.Control type="text" name="nombres" value={passengerData.nombres} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formApellidos">
                            <Form.Label>Apellidos</Form.Label>
                            <Form.Control type="text" name="apellidos" value={passengerData.apellidos} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Nacionalidad</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaNacimiento">
                            <Form.Label>Fecha Nacimiento</Form.Label>
                            <Form.Control type="date" name="fechaNacimiento" value={passengerData.fechaNacimiento} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formSexo">
                            <Form.Label>Sexo</Form.Label>
                            <Form.Control as="select" name="sexo" value={passengerData.sexo} onChange={handleInputChange}>
                                <option value="">Seleccionar</option>
                                <option value="M">Masculino</option>
                                <option value="F">Femenino</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formSexo">
                            <Form.Label>Calidad</Form.Label>
                            <Form.Control as="select" name="sexo" value={passengerData.sexo} onChange={handleInputChange}>
                                <option value="">Seleccionar</option>
                                <option value="M">Alumno</option>
                                <option value="F">Apoderado</option>
                                <option value="F">Invitado</option>
                            </Form.Control>
                        </Form.Group>
                        
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Enfermedad</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Tratamiento</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Tipo Sangre</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Tipo Alimentacion</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseAddPassengerModal}>
                        Cerrar
                    </ButtonComponent>
                    <ButtonComponent variant="primary" className="btn btn-primary" onClick={handleAddPassenger}>
                        Agregar
                    </ButtonComponent>
                </Modal.Footer>
                </div>
            </Modal>


            <Modal show={alertModalAgregar} onHide={()=> setAlertModalAgregar(false)}>
            <div className="mc-alert-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formNombres">
                            <Form.Label>Nombres</Form.Label>
                            <Form.Control type="text" name="nombres" value={passengerData.nombres} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formApellidos">
                            <Form.Label>Apellidos</Form.Label>
                            <Form.Control type="text" name="apellidos" value={passengerData.apellidos} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Calidad</Form.Label>
                            <Form.Select name="calidad" onChange={handleInputChange} >
                                                        <option>Seleccionar Calidad</option>
                                                        {tipoPasajeros.map((tipo) => (
                                                            <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                                                        ))}
                                                    </Form.Select>
                        </Form.Group>
                         
                       
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" className="btn btn-danger" onClick={()=> setAlertModalAgregar(false)}>
                        Cerrar
                    </ButtonComponent>
                    <ButtonComponent variant="primary" className="btn btn-primary" onClick={handleAgregarAlumno}>
                        Agregar
                    </ButtonComponent>
                </Modal.Footer>
                </div>
            </Modal>


            <Modal show={alertModalDetalle} onHide={()=> setAlertModalDetalle(false)}>
            <div className="mc-alert-modal" style={{width: '1300px'}}>
                <Modal.Header closeButton>
                    <Modal.Title>Detalle Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs className="mc-tabs">
                        <Tab eventKey="profile" title="Perfil">
                        <Form>
                        <Form.Group controlId="formNombres">
                            <Form.Label>Nombres</Form.Label>
                            <Form.Control type="text" name="nombres" value={passengerData.nombres}   onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formApellidos">
                            <Form.Label>Apellidos</Form.Label>
                            <Form.Control type="text" name="apellidos" value={passengerData.apellidos}  onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange}  />
                        </Form.Group>
                       
                        <Form.Group controlId="formRUT">
                            <Form.Label>Nacionalidad</Form.Label>
                            <Form.Control type="text" name="nacionalidad" value={passengerData.nacionalidad} onChange={handleInputChange}  />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Fecha Nacimiento</Form.Label>
                            <Form.Control type="date" name="fechaNacimientoAct" value={passengerData.fechaNacimientoAct} onChange={handleInputChange}  />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Edad</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.edad} onChange={handleInputChange} disabled />
                        </Form.Group>

                         <Form.Group controlId="formRUT">
                            <Form.Label>Calidad</Form.Label>
                            <Form.Select name="calidad" onChange={handleInputChange} disabled >
                                                        <option>Seleccionar Calidad</option>
                                                        {tipoPasajeros.map((tipo) => (
                                                              <option key={tipo.id} value={tipo.id} selected={passengerData?.idcalidad === tipo.id}>{tipo.nombre}</option>
                                                        ))}
                                                    </Form.Select>
                        </Form.Group>                                
                       <Form.Group>
                                    <br></br>               
                          <ButtonComponent onClick={handleActualizaDatos}  className="btn btn-primary">Actualizar Datos</ButtonComponent>
                       </Form.Group>
                       

                       
                         
                       
                        
                    </Form>
                        </Tab>
                        <Tab eventKey="password" title=" Pagos" className="mc-tabpane password">
                        <h2>Total Gira: ${valorGiraAlumno.toLocaleString('es-CL')}</h2>
                        <table className="mc-table">
                                            <thead className="mc-table-head primary">
                                                <tr>
                                                <th ></th>   
                                                 <th >Nº Cuota</th>
                                                 <th >vencimiento</th>
                                                 <th >Cuota</th>
                                                 <th >Multa</th>
                                                 <th >A Pagar</th>
                                                 <th >Fecha Pago</th>
                                                 <th >Monto Pagado</th>
                                                 <th >Detalle</th>
                                                
                                                </tr>
                                            </thead>
                                            <tbody className="mc-table-body even">
                                            {cuotasAlumnoGira.map((cuota, index) => {
                                               
                                                    const proximaCuota = cuotasAlumnoGira[index + 1];
                                                    const proximaFechaVencimiento = proximaCuota ? proximaCuota.cou_festpago : null;
                                                  
                                                    
                                               
                                                return (
                                                <tr key={cuota.cuo_id}>
                                                    <td>
                                                    {!cuota.cou_fpago && <input type="checkbox" onChange={() => handleCheckboxChange(cuota, proximaFechaVencimiento)} />}
                                                    </td>
                                                    <td title="id">{cuota.cou_ncuota}</td>
                                                    <td title={cuota.cou_festpago}>{cuota.cou_festpago}</td>
                                                    <td title={cuota.cou_valor}>{cuota.cou_valor.toLocaleString('es-CL')}</td>
                                                    <td title="multa"> 
                                                         {!cuota.cou_fpago ?
                                                          (<input
                                                            className = {`mc-label-field-input w-md h-sm`}     
                                                            type="text"
                                                            value={multasModificadas[cuota.cuo_id] } // Mostrar la multa modificada o la calculada // Mostrar la multa calculada o la modificada
                                                            onChange={(e) => handleMultaChange(cuota.cuo_id, e.target.value)} // Manejar el cambio
                                                            style={{ width: "100px" }} // Ajustar el tamaño del campo de texto
                                                        />): (cuota.cou_multa || 0)}
                                                       </td> {/* Mostrar la multa calculada */}
                                                   <td title="apagar"> {cuota.cou_fpago ?
                                                          ( Math.floor(cuota.cou_valor + (cuota.cou_multa || 0)).toLocaleString('es-CL') ): Math.floor(cuota.cou_valor + multasModificadas[cuota.cuo_id] ).toLocaleString('es-CL')}
                                                        </td>
                                                    <td title={cuota.cou_fpago}>{cuota.cou_fpago}</td>
                                                    <td title={cuota.cou_montopagado}>{cuota.cou_montopagado?.toLocaleString('es-CL')}</td>
                                                    <td title={cuota.cou_detalle}>
                                                          {!cuota.cou_fpago ? (
                                                            <input
                                                            className={`mc-label-field-input w-md h-sm`}
                                                            type="text"
                                                            onChange={(e) => handleDetalleChange(cuota.cuo_id, e.target.value)} // Manejar el cambio
                                                            style={{ width: "80px" }} // Ajustar el tamaño del campo de texto
                                                            />
                                                        ) : (
                                                            <>
                                                            {cuota.cou_detalle}
                                                            {cuota.web_id !== null && <p>Pago con Webpay</p>}
                                                            {cuota.khi_id !== null && <p>Pago con Khipu</p>}
                                                            
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                            </tbody>
                                         </table>
                                          <div className="total-monto">
                                                                 <h5>Total a Pagar: {totalMonto.toLocaleString('es-CL')}</h5>
                                                             </div>
                                                            
                                                             <ButtonComponent onClick={handlePay}  className="btn btn-primary">Pagar</ButtonComponent>
                                   
                        </Tab>
                    </Tabs>
                   
                    
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" className="btn btn-danger" onClick={()=> setAlertModalDetalle(false)}>
                        Cerrar
                    </ButtonComponent>
                   
                </Modal.Footer>
                </div>
            </Modal>

            <Modal show={alertModalEliminar} onHide={() => setAlertModalEliminar(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>¿Desea eliminar este alumno?</h3>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModalEliminar(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={handleDeleteAlumno}>Aceptar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    )
}